import React from 'react';
import Routes from 'routes';
import { ClientConfigurationProvider } from 'components/contexts/ClientConfiguration';
import { UserProvider, UserConsumer } from 'components/contexts/UserContext';
import { LocalizationProvider, LocalizationConsumer } from 'components/contexts/LocalizationContext';

const App = () => {
	return (
		<ClientConfigurationProvider>
			<UserProvider>
				<UserConsumer>
					{user =>
						<LocalizationProvider user={user}>
							<LocalizationConsumer>
								{loca => <Routes />}
							</LocalizationConsumer>
						</LocalizationProvider>
					}
				</UserConsumer>
			</UserProvider>
		</ClientConfigurationProvider>
	)
}

export default App;